import { Button, UIHeading2 } from '@cian/ui-kit';

import { forwardRef } from 'react';

import { Cards } from 'shared/components/Cards';
import { useInitSimilarOffersCardApi } from 'shared/hooks/useInitCardApi';
import { IOfferSchema } from 'shared/repositories/commercial-search-offers/entities/offer/OfferSchema';
import { AdfoxContextData } from 'shared/types/AdfoxContextData';
import { DealType } from 'shared/types/DealType';

import styles from './OtherCards.css';

type OtherCardsProps = {
  adfox: AdfoxContextData['serverData'];
  dealType: DealType;
  hasNextPage: boolean;
  isLoading: boolean;
  offers: IOfferSchema[];
  title: string;
  onMoreButtonClick(): void;
};

export const OtherCards = forwardRef<HTMLDivElement, OtherCardsProps>(function OtherCards(props, ref) {
  const { isLoading, onMoreButtonClick, title, offers, adfox, dealType, hasNextPage } = props;

  const initCardApi = useInitSimilarOffersCardApi();

  return (
    <div ref={ref}>
      <div className={styles['heading-wrapper']}>
        <UIHeading2>{title}</UIHeading2>
      </div>
      <Cards adfox={adfox} dealType={dealType} initCardApi={initCardApi} offers={offers} />
      {hasNextPage && (
        <div className={styles['more-button-wrapper']}>
          <Button disabled={isLoading} loading={isLoading} theme="stroke_secondary" onClick={onMoreButtonClick}>
            Показать ещё
          </Button>
        </div>
      )}
    </div>
  );
});
